// helper to prepend a "Select ..." options
export const prependDefault = (options, label = 'Select') => [
    { value: '', label: `Select ${label}` },
    ...options,
];